import { useLocation } from 'react-router-dom';
import AuthenticationUtil from '../../../util/AuthenticationUtil';
import { SmsRouter } from '../../../util/RouterUtil';
import ViewWrapper from '../../ViewWrapper';

const SmsRouterView = () => {
    const auth = AuthenticationUtil.get();
    const pathname = useLocation().pathname;
    return (
        <div className='body-view'>
            <ViewWrapper router={SmsRouter} />
        </div>
    );
};

export default SmsRouterView;
